// extracted by mini-css-extract-plugin
module.exports = {"adSection":"_u","ad":"_v","borderTop":"_w","borderBottom":"_x","adBlock":"_y"};